import React from "react";
import ScrollTop from "../components/ScrollTop";
import Marktplatz from "../components/Marktplatz";
import Container from "../components/Container";
import { Link } from "react-router";
import SkyLight from "react-skylight";

const Footer = React.createClass({
    propTypes: {
        currentPage: React.PropTypes.string.isRequired,
    },
    render: function () {
        return (
            <footer className="footer">
                <Container>
                    <div className="footer-content">
                        <ScrollTop />
                        <Marktplatz />
                        <div>
                            <SkyLight
                                hideOnOverlayClicked={true}
                                ref="links"
                                title="Links"
                            >
                                <ul>
                                    <li>
                                        {" "}
                                        Frauenärzte im Netz:{" "}
                                        <a
                                            target="_blank"
                                            href="http://www.frauenaerzte-im-netz.de"
                                        >
                                            www.frauenaerzte-im-netz.de
                                        </a>
                                    </li>
                                    <li>
                                        Deutsche Gesellschaft für Gynäkologie
                                        und Geburtshilfe e.V.:{" "}
                                        <a
                                            target="_blank"
                                            href="http://www.dggg.de"
                                        >
                                            www.dggg.de
                                        </a>
                                    </li>
                                    <li>
                                        Berufsverband der Frauenärzte:{" "}
                                        <a
                                            target="_blank"
                                            href="http://www.bvf.de"
                                        >
                                            www.bvf.de
                                        </a>
                                    </li>
                                    <li>
                                        ENTSCHIEDEN. Gegen Krebs:{" "}
                                        <a
                                            target="_blank"
                                            href="https://www.entschiedengegenkrebs.de/"
                                        >
                                            www.entschiedengegenkrebs.de
                                        </a>
                                    </li>
                                </ul>
                            </SkyLight>
                            <a
                                href="javascript: void(0);"
                                onClick={() => this.refs.links.show()}
                            >
                                Links
                            </a>
                            &nbsp;|&nbsp;
                            {/* <Link to="/">Jobs</Link>
                            &nbsp;|&nbsp; */}
                            {this.props.currentPage == "/impressum" ? (
                                <Link to="/">Startseite</Link>
                            ) : (
                                <Link to="/impressum">Impressum</Link>
                            )}
                            &nbsp;|&nbsp;
                            <Link to="/datenschutz">Datenschutz</Link>
                        </div>
                    </div>
                </Container>
            </footer>
        );
    },
});

export default Footer;



// WEBPACK FOOTER //
// ./src/js/containers/Footer.js